import {
  swalErrorMessage,
  swalSuccessMessage,
} from "../../../../Constant/swalMessage";
import {
  AddLeadsService,
  cloneProjectService,
  deleteProjectsService,
  editProjectsService,
  functionsExecuteService,
  getAdvanceSettingsService,
  getLeadDataService,
  getProjectByIdService,
  getProjectSheetsDataService,
  getProjectSheetsService,
  getProjectsService,
  saveAdvanceSettingsService,
  saveProjectsService,
  updateLeadsService,
  uploadMultipleFilesService,
} from "../../services/projects.services";
import { projectsType } from "./projects.type";

export const getProjectsAction = () => async (dispatch) => {
  let res = await getProjectsService();
  if (res) {
    await dispatch({
      type: projectsType.GET_PROJECTS_LIST,
      payload: res?.data,
    });
  }
};

export const getProjectByIdAction = (id) => async (dispatch) => {
  let res = await getProjectByIdService(id);
  if (res) {
    await dispatch({
      type: projectsType.GET_SELECTED_PROJECT,
      payload: res?.data,
    });
    return res?.data;
  }
};

export const saveProjectsAction =
  (obj, swal = true) =>
  async (dispatch) => {
    let res = await saveProjectsService(obj);
    if (res.status === 200) {
      return res;
    } else {
      return res;
    }
  };

export const editProjectsAction =
  (obj, id, displayAlert = true) =>
  async (dispatch) => {
    let res = await editProjectsService(obj, id);
    if (res.status === 200) {
      return true;
    } else {
      swalErrorMessage(res.errMsg);
    }
  };

export const deleteProjectsAction = (id) => async (dispatch) => {
  let res = await deleteProjectsService(id);
  if (res.status === 200) {
    // swalSuccessMessage(res.msg);
    return true;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const getAdvanceSettingAction = (id) => async (dispatch) => {
  let res = await getAdvanceSettingsService(id);
  if (res) {
    await dispatch({
      type: projectsType.GET_ADVANCE_SETTING,
      payload: res?.data,
    });
  }
};

export const saveAdvanceSettingAction = (obj, id) => async (dispatch) => {
  let res = await saveAdvanceSettingsService(obj, id);
  if (res.status === 200) {
    swalSuccessMessage(res.msg);
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const clearProjectReducer = () => async (dispatch) => {
  await dispatch({
    type: projectsType.CLEAR_PROJECT_REDUCER,
    payload: {},
  });
};

export const updateProjectAccessAction = (arr) => async (dispatch) => {
  await dispatch({
    type: projectsType.PROJECT_ACCESS,
    payload: arr,
  });
};

export const getProjectSheetsAction = async (data) => {
  const res = await getProjectSheetsService(data);
  if (res?.status === 200) return res?.data;
};

export const getProjectSheetsDataAction = async (
  paramsdata,
  projectId,
  filters
) => {
  const res = await getProjectSheetsDataService(paramsdata, projectId, filters);
  if (res?.status === 200) return res?.data;
};

export const AddLeadsAction = async (obj) => {
  const res = await AddLeadsService(obj);
  if (res.status === 200) {
    return res;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const updateLeadsAction = async (id, obj) => {
  const res = await updateLeadsService(id, obj);
  if (res.status === 200) {
    return res;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const getLeadsDataAction = (obj) => async (dispatch) => {
  try {
    const res = await getLeadDataService(obj);

    if (res?.status === 200) {
      await dispatch({
        type: projectsType.GET_LEADS_LIST,
        payload: res?.data,
      });
      return res?.data;
    } else {
      swalErrorMessage(res?.errMsg);
    }
  } catch (error) {
    swalErrorMessage("Something went wrong!");
  }
};
export const exportLeadsDataAction = (obj) => async () => {
  try {
    const res = await getLeadDataService(obj);
    if (res?.status === 200) {
      return res?.data;
    } else {
      swalErrorMessage(res?.errMsg);
    }
  } catch (error) {
    swalErrorMessage("Something went wrong!");
  }
};

export const cloneProjectAction = (data) => async (dispatch) => {
  const res = await cloneProjectService(data);
  if (res?.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const functionsExecuteAction = (data) => async (dispatch) => {
  const res = await functionsExecuteService(data);

  if (res?.status === 200) {
    return res?.data;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const uploadMultipleFilesAction = (obj) => async () => {
  const res = await uploadMultipleFilesService(obj);
  if (res?.status === 200) {
    return res?.data;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};
